import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import AccountWidget from "../../components/shared/AccountWidget";
import { Link } from "react-router-dom";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import Loading from "../../components/shared/Loading";
import { fetchOrders } from "../../store/actions/order";
import styles from "../../thema/style";
import moment from "moment";
import "moment/locale/tr";
import "../../styles/ModernOrderHistory.css";
moment.locale("tr");

class AccountOrdersHistory extends Component {
  componentDidMount() {
    this.props.fetchOrders();
  }

  render() {
    if (this.props.customer.fetching) {
      return (
        <div className="modern-order-history-container">
          <div className="container">
            <div className="order-history-loading">
              <div className="loading-spinner"></div>
              <div className="loading-text">Sayfa Yükleniyor...</div>
            </div>
          </div>
        </div>
      );
    } else {
      if (!this.props.customer.customer) {
        return (
          <Redirect
            to={{
              pathname: "/giris-yap",
              // state: { referrer: currentLocation }
            }}
          />
        );
      }
      const orders = this.props.order.orders.filter(
        ({ status }) => status === "Tamamlandı"
      );

      // Calculate stats
      const totalOrders = orders.length;
      const totalProducts = orders.reduce(
        (sum, order) => sum + order.products.length,
        0
      );
      const avgOrderValue =
        totalOrders > 0
          ? orders.reduce(
              (sum, order) => sum + parseFloat(order.total_price),
              0
            ) / totalOrders
          : 0;

      return (
        <React.Fragment>
          <PageTitle title={"Sipariş Geçmişim"} />
          <div className="modern-order-history-container">
            <div className={"container"}>
              <div className="row">
                <div className={"col-md-9"}>
                  {/* Modern Header */}
                  <div className="modern-order-history-header">
                    <div className="order-history-header-content">
                      <h1 className="order-history-title">
                        <FontAwesomeIcon icon="history" />
                        Sipariş Geçmişim
                      </h1>
                      <p className="order-history-subtitle">
                        Tamamlanan siparişlerinizi görüntüleyin ve tekrar
                        sipariş verin
                      </p>
                      <div className="order-history-breadcrumb">
                        <Link to="/hesabim">Hesabım</Link>
                        {" / "}
                        <span>Sipariş Geçmişim</span>
                      </div>
                    </div>
                  </div>

                  {/* Stats Cards */}
                  {orders.length > 0 && (
                    <div className="order-history-stats">
                      <div className="stats-card">
                        <div className="stats-icon">
                          <FontAwesomeIcon icon="shopping-bag" />
                        </div>
                        <div className="stats-value">{totalOrders}</div>
                        <div className="stats-label">Başarılı Sipariş</div>
                      </div>
                      <div className="stats-card">
                        <div className="stats-icon">
                          <FontAwesomeIcon icon="heart" />
                        </div>
                        <div className="stats-value">
                          ₺{avgOrderValue.toFixed(0)}
                        </div>
                        <div className="stats-label">Ortalama Sepet</div>
                      </div>
                      <div className="stats-card">
                        <div className="stats-icon">
                          <FontAwesomeIcon icon="star" />
                        </div>
                        <div className="stats-value">{totalProducts}</div>
                        <div className="stats-label">Favori Ürün</div>
                      </div>
                    </div>
                  )}

                  {/* Order Content */}
                  {this.props.order.fetching ? (
                    <div className="order-history-loading">
                      <div className="loading-spinner"></div>
                      <div className="loading-text">
                        Sipariş Geçmişi Yükleniyor...
                      </div>
                    </div>
                  ) : orders.length > 0 ? (
                    <div className="order-history-grid">
                      {orders.map((order, i) => (
                        <div key={i} className="order-history-card">
                          <div className="order-history-card-header">
                            <div className="order-number">
                              <div className="order-number-icon">
                                <FontAwesomeIcon icon="receipt" />
                              </div>
                              <span>Sipariş #{order.c_number}</span>
                            </div>
                            <div className="order-status-badge">
                              {order.status}
                            </div>
                          </div>

                          <div className="order-history-details">
                            <div className="order-detail-item">
                              <div className="order-detail-label">
                                Sipariş Tarihi
                              </div>
                              <div className="order-detail-value">
                                <FontAwesomeIcon
                                  icon="calendar-alt"
                                  className="order-detail-icon"
                                />
                                {moment(order.created_at).format(
                                  "DD MMMM YYYY"
                                )}
                              </div>
                            </div>

                            <div className="order-detail-item">
                              <div className="order-detail-label">
                                Ürün Sayısı
                              </div>
                              <div className="order-detail-value">
                                <FontAwesomeIcon
                                  icon="box"
                                  className="order-detail-icon"
                                />
                                {order.products.length} Adet
                              </div>
                            </div>

                            <div className="order-detail-item">
                              <div className="order-detail-label">
                                Sipariş Tutarı
                              </div>
                              <div className="order-detail-value order-total-price">
                                <FontAwesomeIcon
                                  icon="lira-sign"
                                  className="order-detail-icon"
                                />
                                ₺{parseFloat(order.total_price).toFixed(2)}
                              </div>
                            </div>

                            <div className="order-detail-item">
                              <div className="order-detail-label">
                                Teslimat Süresi
                              </div>
                              <div className="order-detail-value">
                                <FontAwesomeIcon
                                  icon="truck"
                                  className="order-detail-icon"
                                />
                                {moment(order.created_at).fromNow()}
                              </div>
                            </div>
                          </div>

                          <div className="order-history-actions">
                            <Link
                              className="order-action-btn view-order-btn"
                              to={{
                                pathname: "/hesabim/siparis/detay",
                                state: {
                                  id: order.id,
                                },
                              }}
                            >
                              <FontAwesomeIcon icon="eye" />
                              Detayları Gör
                            </Link>
                            <button
                              className="order-action-btn reorder-btn"
                              onClick={() => {
                                // Tekrar sipariş functionality buraya eklenebilir
                              }}
                            >
                              <FontAwesomeIcon icon="redo" />
                              Tekrar Sipariş
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="order-history-empty-state">
                      <div className="empty-state-icon">
                        <FontAwesomeIcon icon="history" />
                      </div>
                      <h3 className="empty-state-title">
                        Henüz Tamamlanan Sipariş Yok
                      </h3>
                      <p className="empty-state-description">
                        Tamamlanan siparişiniz bulunmamaktadır. İlk siparişinizi
                        vererek alışverişe başlayın!
                      </p>
                      <Link to="/" className="empty-state-action">
                        <FontAwesomeIcon icon="shopping-cart" />
                        Alışverişe Başla
                      </Link>
                    </div>
                  )}
                </div>
                <div className={"col-md-3"}>
                  <AccountWidget />
                  <CategoriesWidget />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = ({ customer, order }) => {
  return { customer, order };
};

const mapDispatchToProps = { fetchOrders };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountOrdersHistory);



// WEBPACK FOOTER //
// ./src/routers/Account/orders_history.js